<template>
    <div id="search_page">
        <router-view v-if="!isMobile" name="nav"></router-view>
        <router-view v-if="!isMobile" name="main"></router-view>
        <router-view v-if="isMobile" name="mobile_nav"></router-view>
        <router-view v-if="isMobile" name="mobile_main"></router-view>

        <router-view name="orderedItem_detail"></router-view>
        <router-view name="finishedItem_detail"></router-view>
        <router-view name="parcelItem_detail"></router-view>
        <router-view name="loading"></router-view>
        <router-view name="popup"></router-view>
        <router-view name="photo"></router-view>
        <router-view name="user_edit"></router-view>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            isMobile: 0,
        }
    },
    created() {
        this.$store.commit("setPage", "search");
        this.isMobile = window.innerWidth < 600;
    },
}
</script>

<style>
#search_page {
    width:100%;
}
</style>


// WEBPACK FOOTER //
// src/components/SearchPage.vue